"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findConfigByScript = findConfigByScript;
exports.nameOfScript = nameOfScript;
var _manager = require("./manager");
function findConfigByScript(scriptTemplate, SCRIPTS) {
  const scripts = SCRIPTS || (0, _manager.getConfig)().SCRIPTS;
  return Object.values(scripts).find(item => (item === null || item === void 0 ? void 0 : item.CODE_HASH) === scriptTemplate.codeHash && (item === null || item === void 0 ? void 0 : item.HASH_TYPE) === scriptTemplate.hashType);
}

/**
 *
 * We may need to determine if a `scriptTemplate` is a kind of ScriptConfig
 *
 * ```typescript
 * if (keyOfScript({ codeHash... })  === 'SECP256K1')  {
 *   // ...
 * }
 * ```
 * @param scriptTemplate
 * @param SCRIPTS
 */
function nameOfScript(scriptTemplate, SCRIPTS) {
  const scripts = SCRIPTS || (0, _manager.getConfig)().SCRIPTS;
  const foundEntry = Object.entries(scripts).find(([, config]) => (config === null || config === void 0 ? void 0 : config.CODE_HASH) === scriptTemplate.codeHash && (config === null || config === void 0 ? void 0 : config.HASH_TYPE) === scriptTemplate.hashType);
  if (!foundEntry) return undefined;
  return foundEntry[0];
}
//# sourceMappingURL=helpers.js.map